import { selector } from 'recoil';
import { User } from '../types/user';
import { persistedAtom } from '../utils/persistence';

export const accountState = persistedAtom<User | undefined>('app.account', undefined);

export const accountPermissionsState = selector({
  key: 'app.account.permissions',
  get: ({ get }) => {
    const account = get(accountState);
    if (!account) return;
    return account.permissions;
  },
});

export const isAdminState = selector({
  key: 'app.account.isAdmin',
  get: ({ get }) => {
    const account = get(accountState);
    if (!account) return false;

    return account.client ? false : true;
  },
});

export const isSubaccountState = selector({
  key: 'app.account.isSubaccount',
  get: ({ get }) => {
    const account = get(accountState);
    if (!account) return false;
    const isAdmin = get(isAdminState);

    return !isAdmin && account.subAccount ? true : false;
  },
});
